import { authProblemTypes } from '@pm-tool/shared';
import { QueryCache, QueryClient } from '@tanstack/react-query';
import { ApiError } from './api-client';

/** Session ended (401) or TOTP setup pending (403); the router decides where to go. */
export function isSessionError(error: unknown): boolean {
  return (
    error instanceof ApiError &&
    (error.status === 401 ||
      (error.status === 403 && error.problem?.type === authProblemTypes.twoFactorSetupRequired))
  );
}

export function createQueryClient(options: { onSessionError?: () => void } = {}): QueryClient {
  return new QueryClient({
    queryCache: new QueryCache({
      onError: (error) => {
        if (isSessionError(error)) options.onSessionError?.();
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        // Client errors (404 for invisible objects, 403, validation) will not heal by retrying.
        retry: (failureCount, error) =>
          !(error instanceof ApiError && error.status >= 400 && error.status < 500) &&
          failureCount < 2,
      },
    },
  });
}
